export default __webpack_public_path__ + "static/media/pic1.10de7bd4.jpg";